import { RowActionMui } from '@app/components/table/RowActionMui';
import { RowActions } from '@app/components/table/RowActions';
import { buildLoggerStreamUrl } from '@app/modules/logger/screens/stream/helpers/build-logger-stream-url';
import { useStreamQualityReportCapture } from '../hooks/useStreamQualityReportCapture';
import { TimelineTooltipPayload } from '../lib/timeline-tooltip-types';
import { MinimumStation, Station } from '@mi-front/core';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useCallback } from 'react';
import { defineMessage, useIntl } from 'react-intl';

const openLoggerAtTimeMessage = defineMessage({
  id: 'logger.reports.streamQuality.availability.table.action.openLogger',
  defaultMessage: 'Abrir el logger en este momento',
});

export type OpenLoggerRowActionProps = {
  station: Station | MinimumStation;
  /** Row incident payload for PostHog and logger cursor time. */
  payload: TimelineTooltipPayload;
};

/**
 * Row action: navigate to the logger stream for the station at the incident start (new tab).
 */
export function OpenLoggerRowAction({ station, payload }: OpenLoggerRowActionProps) {
  const { $t } = useIntl();
  const { openLogger } = useStreamQualityReportCapture();

  const handleOpen = useCallback(() => {
    openLogger({ source: 'issues_table', payload });
    const url = buildLoggerStreamUrl(station.slug, {
      cursor: payload.start.getTime(),
    });
    window.open(url, '_blank', 'noopener,noreferrer');
  }, [openLogger, payload, station.slug]);

  return (
    <RowActions>
      <RowActionMui title={$t(openLoggerAtTimeMessage)} onClick={handleOpen}>
        <OpenInNewIcon fontSize="small" />
      </RowActionMui>
    </RowActions>
  );
}
